module.exports = __webpack_public_path__ + "01_long_black.30772f52.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/aoyama/daughter/layer5/01_long_black.png
// module id = 05Ie
// module chunks = 0